export const DragHandleIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M7.5 13.333C8.42047 13.333 9.16699 14.0795 9.16699 15C9.16699 15.9205 8.42047 16.667 7.5 16.667C6.57953 16.667 5.83301 15.9205 5.83301 15C5.83301 14.0795 6.57953 13.333 7.5 13.333ZM12.5 13.333C13.4205 13.333 14.167 14.0795 14.167 15C14.167 15.9205 13.4205 16.667 12.5 16.667C11.5795 16.667 10.833 15.9205 10.833 15C10.833 14.0795 11.5795 13.333 12.5 13.333ZM7.5 8.33301C8.42047 8.33301 9.16699 9.07953 9.16699 10C9.16699 10.9205 8.42047 11.667 7.5 11.667C6.57953 11.667 5.83301 10.9205 5.83301 10C5.83301 9.07953 6.57953 8.33301 7.5 8.33301ZM12.5 8.33301C13.4205 8.33301 14.167 9.07953 14.167 10C14.167 10.9205 13.4205 11.667 12.5 11.667C11.5795 11.667 10.833 10.9205 10.833 10C10.833 9.07953 11.5795 8.33301 12.5 8.33301ZM7.5 3.33301C8.42047 3.33301 9.16699 4.07953 9.16699 5C9.16699 5.92047 8.42047 6.66699 7.5 6.66699C6.57953 6.66699 5.83301 5.92047 5.83301 5C5.83301 4.07953 6.57953 3.33301 7.5 3.33301ZM12.5 3.33301C13.4205 3.33301 14.167 4.07953 14.167 5C14.167 5.92047 13.4205 6.66699 12.5 6.66699C11.5795 6.66699 10.833 5.92047 10.833 5C10.833 4.07953 11.5795 3.33301 12.5 3.33301Z"
        fill="currentColor"
      />
    </svg>
  );
};
